<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <span class="a-fs-16 a-fw-b">广告管理</span>
            <div class="a-flex-rcc">
                <el-button icon="el-icon-upload2" @click="exportfile">导出禁用链接</el-button>
                <el-button icon="el-icon-plus" type="primary"  @click="handlerAdd()">创建</el-button>
            </div>
        </div>
        <el-card class="el-main">
            <le-search-form @reset="handlerRest" @search="handlerSearch" :canPackUp="false" id="leSearch">
                <le-date-range 
                    label="开启日期" 
                    :minDate.sync="pageParam.params.startTime" 
                    :maxDate.sync="pageParam.params.endTime" 
                    :pickerOptions='pickerOptions' 
                    :defaultTime="['00:00:00','23:59:59']"
                    valueFormat="yyyy-MM-dd HH:mm:ss" />
                <le-input-district-choose label="区域" 
                    :province.sync="pageParam.params.provinceCode" 
                    :city.sync="pageParam.params.cityCode" 
                    :area.sync="pageParam.params.districtCode"></le-input-district-choose>
                <le-company-under-select label="运营商户" v-model="pageParam.params.operateCompanyId"></le-company-under-select>
                <le-select-remote-search label="项目" v-model="pageParam.params.incomeId" :options="optionsincomeDistri" placeholder="请选择（可输入搜索）" />
                <le-select-remote-search label="站点" v-model="pageParam.params.stationId" :options="optionsStation" placeholder="请选择（可输入搜索）" />
                <le-select-local-search label="广告状态" multiple collapse v-model="pageParam.params.adAuthScopList" :options="adAuthScopDic" />
            </le-search-form>
            <le-pagview ref="adPage" @setData="setTableData" :pageParam="pageParam" :isFixed="true" :tableRef="$refs.adPageList">
                <el-table 
                    ref="adPageList"
                    :data="tableData" 
                    :highlight-current-row="true" 
                    v-sticky="{ top: 0, parent:'.el-card__body' }"
                    style="width: 100%">
                    <el-table-column prop="" label="站点名称" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.stationName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="区域" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.provinceName || '-' }}-{{ row.cityName || '-' }}-{{ row.districtName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="项目" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.incomeName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="运营商户" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.operateCompanyName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="广告状态" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.adAuthScop |initDic(adAuthScopDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="开启日期" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.restartTime || '-' }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="" label="启用数量" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.startAdNum || 0 }}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="" label="最后编辑人" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.updateUserName || '-' }}-{{ row.updateUserPhone || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateTime" label="最后编辑时间" min-width="120"></el-table-column>
                    <el-table-column prop="name" label="操作" width="80" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" v-if="scope.row.adAuthScop == 0" @click="handleOpen(scope.row)">开启广告</el-button>
                            <el-button type="text" class="a-c-error"  v-if="scope.row.adAuthScop == 2" @click="handlerEdit(scope.row)">关闭广告</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </le-pagview>
        </el-card>
        <station-ad-setting ref="adSetting" @change='adSettingSuccess' :adType='1'></station-ad-setting>
    </div>
</template>

<script>
import util from '@/utils/util'
import stationAdSetting from './components/station-ad-setting'
export default {
    components: {
        stationAdSetting
    },
    data() {
        return {
            util,
            tableData: [],
            pageParam: {
                url: this.$Config.apiUrl.stationAdPageVoPage,
                method: "post",
                params: {
                    "adType": 1,//0-系统内广告 1-开屏广告
                    "adAuthScop": "",
                    adAuthScopList: [],
                    "cityCode": "",
                    "districtCode": "",
                    "incomeId": "",
                    "operateCompanyId": "",
                    "provinceCode": "",
                    "stationId": "",
                    "startTime": "",
                    "endTime": ""
                },
                freshCtrl: 1,
            },
            adAuthScopDic: [
                {
                    label: '全部开启',
                    value: '2'
                },
                {
                    label: '部分开启',
                    value: '1'
                },
                {
                    label: '全部关闭',
                    value: '0'
                }
            ],
            optionsStation: {
                url: this.$Config.apiUrl.getStationList,
                method: "post",
                params: {
                    incomeId: ''
                },
                showLoading: false,
                labelKey: "name",
                valueKey: "stationId",
                searchKey: "name",  //incomeDistriId
                pageSize: 200
            },//站点数据
            optionsincomeDistri: {
                url: this.$Config.apiUrl.incomeDistriList,
                method: "post",
                params: {},
                showLoading: false,
                labelKey: "name",
                valueKey: "id",
                searchKey: "name",
            },//项目数据
        };
    },
    mounted () {

    },  
    activated () {
		this.pageParam.freshCtrl++;
	},
    methods: {
        setTableData(data) {
            this.tableData = data;
        },
        handlerRest() {
            this.pageParam.params = {
                "adType": 1,//0-系统内广告 1-开屏广告
                "adAuthScop": "",
                "cityCode": "",
                "districtCode": "",
                "incomeId": "",
                "operateCompanyId": "",
                "provinceCode": "",
                "stationId": "",
                "startTime": "",
                "endTime": "",
                adAuthScopList: [],
            };
            this.handlerSearch()
        },
        handlerSearch() {
            this.$refs['adPage'].pageNum = 1
            this.pageParam.freshCtrl++;
        },
        handlerEdit (datas) {
            this.$refs['adSetting'].id = datas.id
            this.$refs['adSetting'].stationId = datas.stationId
            this.$refs['adSetting'].getInfo()
        },
        adSettingSuccess () {
            this.pageParam.freshCtrl++;
        },
        handlerAdd (datas) {
            this.$router.push({
			    path: "/advertisement/advertisement-edit",
				query: {
				    id: datas ? datas.id : '',
                    adType: 1
				},
			});
        },
        handlerToInfo (datas) {
            this.$router.push({
			    path: "/advertisement/advertisement-info",
				query: {
				    id: datas ? datas.id : '',
				},
			});
        },
        handleOpen (data) {
            this.$confirm('是否确认开启该站点封面广告？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(res=>{
                let reqData
                reqData = {
                    "adSetValue": {
                        "adReStartTime": '',
                        "reStartDay": ''
                    },
                    "adType": 1,
                    "adAuthScop": 2,
                    "stationIds": [data.stationId]
                }
                this.$Axios._post({
                    url: this.$Config.apiUrl.setStationAd,
                    method: "post",
                    params: reqData,
                })
                .then(res=>{
                    if (res.result.code == 0) {
                        this.$alert('操作成功，请重新导出开屏广告禁用链接表，并上传到微信服务台')
                        this.pageParam.freshCtrl++
                    } else {
                        this.$message.error(res.result.message)
                    }
                })
                .catch(err=>{

                })
            })
        },
        exportfile () {
            this.$exfile({
                code: 43,
                fileName: `微信小程序开屏广告控制表${this.$getDay.getToday()}`,
                // startTime: startDate,
                // endTime: endDate,
                params: {
                    ...this.pageParam.params,
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
